import { JSX } from 'react'

import { Separator } from '@chakra-ui/react'

import { HttpBody } from '@/lib/request.js'

import * as locally from '@/lib/locally.js'
import * as detective from '@/lib/detective.js'

import * as company_storage from '@/storage/company.js'


// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Loader from '@/components/ui/loader.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Carte from '@/components/ui/carte.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Menu from '@/components/ui/menu.tsx'




export enum Active
{
	view = 'view',
	update = 'update',
	delete = 'delete',

}

export type RetrieveResult = HttpBody<company_storage.TContractHydratedDocumentType>


// eslint-disable-next-line @typescript-eslint/naming-convention
export function User
(
	props: {
		value: RetrieveResult

	},

)
:	JSX.Element
{
	let { user, archive } = props.value

	return (
		<Carte.Posy
			name={archive?.name ?? '未知用户'}
			text={user?.phone ?? '未知号码'}
			avatar={user?.avatar || archive?.idcard}
			// eslint-disable-next-line @typescript-eslint/naming-convention
			w={{ 'base': 24, '2xl': 48 }}
			size="2xl"

		/>

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Age
(
	props: {
		value: RetrieveResult

	},

)
:	JSX.Element
{
	let { archive } = props.value

	return (
		// eslint-disable-next-line @typescript-eslint/naming-convention
		<Carte.Feild label="年龄" w="24" display={{ 'base': 'none', '2xl': 'flex' }}>
			<Carte.B>{archive?.age ?? '未知'}</Carte.B>

		</Carte.Feild>

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Sex
(
	props: {
		value: RetrieveResult

	},

)
:	JSX.Element
{
	let { archive } = props.value

	return (
		<Carte.Feild label="性别" w="24" display={{ base: 'none', xl: 'flex' }}>
			<Carte.B>{archive?.sex ?? '未知'}</Carte.B>
		</Carte.Feild>

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Office
(
	props: {
		value: RetrieveResult

	},

)
:	JSX.Element
{
	let { office } = props.value

	return (
		<Carte.Feild label="岗位" w="72" align="start" boxSizing="content-box">
			<Carte.B>{office || '无'}</Carte.B>

		</Carte.Feild>

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Insurance
(
	props: {
		value: RetrieveResult

	},

)
:	JSX.Element
{
	let { insurance } = props.value

	return (
		<Carte.Feild label="险种" w="32">
			<Carte.B>{insurance || '无'}</Carte.B>
		</Carte.Feild>

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Finish
(
	props: {
		value: RetrieveResult

	},

)
:	JSX.Element
{
	let { finish, lave } = props.value

	let date = '无'
	let lave_text = ''

	if (detective.is_required_string(finish) )
	{
		date = locally.date(finish, { default: '无', format: 'YYYY-MM-DD' })

	}

	if (lave > 0)
	{
		lave_text = `(${lave}天)`

	}

	return (
		<Carte.Feild label="协议至" flex="auto" minW="36" align="start">
			<Carte.B>{date}</Carte.B>
			<Carte.Span>{lave_text}</Carte.Span>

		</Carte.Feild>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Item
(
	props: {
		value: RetrieveResult

		view?(_id: string): void
		update?(_id: string): void
		delete?(_id: string, name: string): void

	},

)
:	JSX.Element
{
	let { _id, name } = props.value.archive

	let on_active = (v: Active): void =>
	{
		if (v === Active.view)
		{
			props.view?.(_id)

		}

		if (v === Active.update)
		{
			props.update?.(_id)

		}

		if (v === Active.delete)
		{
			props.delete?.(_id, name)

		}

	}

	return (
		<>
			<Loader.Item
				p="4"
				display="flex"
				alignItems="center"
				minW="fit-content"
				_hover={{ bg: 'bg.subtle' }}
			>
				<User value={props.value} />
				<Age value={props.value} />
				<Sex value={props.value} />

				<Carte.Divider />

				<Office value={props.value} />
				<Insurance value={props.value} />
				<Finish value={props.value} />

				<Menu.Root icon={<Menu.Icon />} active={on_active}>
					<Menu.Item value={Active.view}>查看</Menu.Item>
					<Menu.Item value={Active.update}>更新</Menu.Item>

					<Menu.Item value={Active.delete} color="fg.error" _hover={{ bg: 'bg.error', color: 'fg.error' }}>重置</Menu.Item>

				</Menu.Root>

			</Loader.Item>

			<Separator ml="4" />

		</>

	)

}


export default function
(
	props: {
		_id    : string
		keyword: string

		view?(_id: string): void
		update?(_id: string): void
		delete?(_id: string, name: string): void

	},

)
:	JSX.Element
{
	let params = {
		keyword : props.keyword,
		resigned: null,

	}

	let on_view = (_id: string): void =>
	{
		props.view?.(_id)

	}

	let on_update = (_id: string): void =>
	{
		props.update?.(_id)

	}

	let on_delete = (_id: string, name: string): void =>
	{
		props.delete?.(_id, name)

	}

	return (
		<Loader.Root
			display="flex"
			flexDirection="column"
			params={params}
			handle={(...args) => company_storage.retrieve_contracts(props._id, ...args)}
		>
			{v => <Item key={v._id} value={v} view={on_view} update={on_update} delete={on_delete} />}

		</Loader.Root>

	)


}
